import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
// import CopyrightFooter from '../../assets/copyright';

export const ModelBase: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        Height: '100vh',
        backgroundColor: 'red',
      }}
    >
      <Outlet />
    </Box>
  );
};
